import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { TableComponent } from './table/table.component';
import { SharedModule } from '../modules/shared.module';
import { PdfComponent } from './pdf/pdf.component';
import { StrechComponent } from './strech/strech.component';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { MaterialBaseModule } from '../modules/material-base.module';
import { RidComponent } from './rid/rid.component';
import { RidFornecedorComponent } from './ridFornecedor/ridFornecedor.component';
import { ExpenseDetailComponent } from './rid/expense-detail/expense-detail.component';
import { ExpenseDetailComponent as RidFornecedorExpenseDetailComponent } from './ridFornecedor/expense-detail/expense-detail.component';
import { PhoneBillsComponent } from './phone-bills/phone-bills.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CURRENCY_MASK_CONFIG, CurrencyMaskModule } from "ng2-currency-mask";

const maskConfig: Partial<IConfig> = {
  validation: false,

};

export const customCurrencyMaskConfig = {
  align: "left",
  allowNegative: false,
  nullable: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: "."
};

@NgModule({
  declarations: [
    TableComponent,
    PdfComponent,
    StrechComponent,
    RidComponent,
    ExpenseDetailComponent,
    RidFornecedorExpenseDetailComponent,
    PhoneBillsComponent,
    RidFornecedorComponent
  ],
  imports: [
    MaterialBaseModule,
    SharedModule,
  //  TooltipModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgSelectModule,
    NgxPaginationModule,
    NgbModule,
    CurrencyMaskModule,
    CommonModule,
    FlexLayoutModule, 
  ],
  exports:[
    TableComponent,
    PdfComponent,
    StrechComponent,
    RidComponent,
    ExpenseDetailComponent,
    RidFornecedorExpenseDetailComponent,
    PhoneBillsComponent,
    RidFornecedorComponent
  ],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: customCurrencyMaskConfig }
  ]
})
export class ComponentsModule { }
